const sections = [];
const state = {
    section: 0,
    question: 0
};

const currentQuestion = () => sections[state.section].questions[state.question];
const currentSection = () => sections[state.section];
const totalQuestions = () => sections.reduce((total, section) => total + section.questions.length, 0);

const currentQuestionNumber = () => {
    let number = 0;

    for (let i = 0; i < state.section; i++) {
        number += sections[i].questions.length;
    }

    return number + state.question + 1;
};

export function mountQuiz() {
    const quiz = document.querySelector('.whf-quiz');
    if (!quiz) return;

    const startButton = quiz.querySelector('.launch-quiz button');
    if (!startButton) return;

    startButton.addEventListener('click', launchQuiz);

    initResultsObserver();
}

const launchQuiz = () => {
    const launchScreen = document.querySelector('.whf-quiz__launch-screen');
    const form = document.querySelector('.whf-quiz__form');
    if (!launchScreen || !form) return;

    form.classList.toggle('hidden');
    launchScreen.classList.toggle('hidden');

    const fields = form.querySelectorAll('.gform_fields > .gfield');
    if (!fields) return;

    let activeSection;
    fields.forEach(field => {
        if (field.classList.contains('gfield--type-section')) {
            activeSection = {
                title: field.querySelector('.gsection_title').textContent.trim(),
                element: field,
                questions: []
            };

            sections.push(activeSection);
            return;
        }

        if (field.classList.contains('gfield--type-quiz')) {
            activeSection.questions.push(field);
        }
    });

    const submitButton = form.querySelector('input[type="submit"]');
    submitButton.classList.add('hidden');

    const nextQuestionButton = form.querySelector('.whf-button');;

    buildProgress();
    showQuestion();
    updateProgress();

    form.addEventListener('change', (e) => {
        const input = e.target;
        if (!input.matches('.gfield-choice-input[type="radio"]')) return;

        const isLastQuestion = state.section === sections.length - 1 && state.question === currentSection().questions.length - 1;

        if (isLastQuestion) {
            submitButton.classList.remove('hidden');
        } else {
            nextQuestionButton.classList.remove('hidden');
        }
    });

    nextQuestionButton.addEventListener('click', () => {
        nextQuestion();
        nextQuestionButton.classList.add('hidden');
    });
}

const nextQuestion = () => {
    if (state.section === sections.length - 1 && state.question === currentSection().questions.length - 1) {
        return false;
    }

    currentQuestion().classList.add('hidden');

    if (state.question < currentSection().questions.length - 1) {
        state.question++;
    } else if (state.section < sections.length - 1) {

        currentSection().element.classList.add('hidden');

        state.section++;
        state.question = 0;

        currentSection().element.classList.remove('hidden');
    } else {
        return;
    }

    currentQuestion().classList.remove('hidden');

    const counter = document.querySelector('.question-counter');
    if (!counter) return;
    counter.innerHTML = `${currentQuestionNumber()}<span class="question-counter-total">/${totalQuestions()}</span>`;

    updateProgress();
}

const showQuestion = () => {
    sections.forEach(section => {
        section.element.classList.add('hidden');
        section.questions.forEach(question => {
            question.classList.add('hidden');
        });
    });

    sections[state.section].element.classList.remove('hidden');
    sections[state.section].questions[state.question].classList.remove('hidden');

    const counter = document.querySelector('.question-counter');
    if (!counter) return;
    counter.innerHTML = `${currentQuestionNumber()}<span class="question-counter-total">/${totalQuestions()}</span>`;
};

const buildProgress = () => {
    const progress = document.querySelector('.progress-pips');
    if (!progress) return;

    const createMilestone = (number, title = '') => {
        const milestone = document.createElement('div');

        milestone.className = 'progress-pip';

        if (number === 1) {
            milestone.classList.add('is-active');
        }

        milestone.innerHTML = `
            ${title ? `<span class="progress-title">${title}</span>` : ''}
            <span class="progress-number">
                ${String(number).padStart(2, '0')}
            </span>
        `;

        progress.appendChild(milestone);

        return milestone;
    };

    progress.innerHTML = '';

    // Starting milestone
    createMilestone(1);

    let milestone = 0;

    sections.forEach(section => {
        milestone += section.questions.length;

        section.progressElement = createMilestone(
            milestone,
            section.title
        );
    });
};

const updateProgress = () => {
    sections.forEach((section, index) => {
        section.progressElement.classList.toggle(
            'is-complete',
            index < state.section
        );
    });

    const fill = document.querySelector('.progress-fill');
    if (!fill) return;

    const completedQuestions = currentQuestionNumber() - 1;
    const total = totalQuestions();

    const percentage = (completedQuestions / total) * 100;

    fill.style.width = `${percentage}%`;
};

// Observer to check when confirmation is shown, as the expected Gravity Form events aren't emitted properly.
const initResultsObserver = () => {
    const formWrapper = document.querySelector('.whf-quiz__form');
    const resultsWrapper = document.querySelector('.whf-quiz__results');
    if (!formWrapper || !resultsWrapper) return;

    const observer = new MutationObserver(() => {
        const confirmation = formWrapper.querySelector('.gform_confirmation_wrapper .gform_confirmation_message');
        if (!confirmation) return;

        observer.disconnect();
        formWrapper.classList.add('hidden');
        resultsWrapper.classList.remove('hidden');

        const messageArea = resultsWrapper.querySelector('.results-message');
        messageArea.appendChild(confirmation);

        const shareButton = document.querySelector('.whf-quiz__share-button');
        shareButton.addEventListener('click', async () => {
            console.log('Share button clicked');
            const matches = confirmation.textContent.match(/(\d+)\s+of\s+(\d+)/i);

            if (matches) {
                const score = Number(matches[1]);
                const total = Number(matches[2]);

                const shareData = {
                    title: 'World Heart Day 2026 Quiz',
                    text: `I scored ${score} out of ${total} on the World Heart Day 2026 Quiz. Join me in raising awareness of heart health! Take the quiz and see how you score!`,
                    url: window.location.href
                };

                if (navigator.share) {
                    await navigator.share(shareData);
                } else {
                    await navigator.clipboard.writeText(
                        `${shareData.text}\n\n${shareData.url}`
                    );
                }
            }
        });
    });

    observer.observe(formWrapper, {
        childList: true,
        subtree: true
    });
};
